module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab101-458ca4aefea3d358020c9f21bc414982.jpg";